module.exports = require("./nb.d.ts");